"use strict";

exports.__esModule = true;
exports.getPosts = getPosts;
exports.blogRoutes = blogRoutes;
exports.BlogTitle = exports.BlogMenuTitle = exports.BlogPath = exports.BlogSegment = void 0;

var _getPath = require("../../../../react-static/route/getPath");

var _createRoute = require("../../../../react-static/route/createRoute");

var _formatDateLong = require("../../../../datetime/formatDateLong");

var _convertMatter = require("../../../../react-static/markdown/convert/convertMatter");

var _convertDate = require("../../../../react-static/markdown/convert/convertDate");

var _sortDate = require("../../../../react-static/markdown/sort/sortDate");

var _BlogPosts = require("../blogPosts/BlogPosts");

var BlogSegment = "blog";
exports.BlogSegment = BlogSegment;
var BlogPath = (0, _getPath.getPath)(BlogSegment);
exports.BlogPath = BlogPath;
var BlogMenuTitle = "Blog";
exports.BlogMenuTitle = BlogMenuTitle;
var BlogTitle = "Blog Posts";
exports.BlogTitle = BlogTitle;

function getPosts(blogPostsMatter) {
  (0, _convertMatter.convertMatter)(blogPostsMatter, [_convertDate.convertDate]);
  blogPostsMatter = blogPostsMatter.sort(_sortDate.sortDateByRecent);
  var posts = blogPostsMatter.map(function (postMatter) {
    var postData = {
      title: postMatter.data.title,
      path: (0, _BlogPosts.BlogPostPath)(postMatter.data.slug),
      excerpt: postMatter.excerpt,
      postInfo: {
        date: (0, _formatDateLong.formatDateLong)(postMatter.data.date)
      }
    };
    return postData;
  });
  return posts;
}

function blogRoutes(rootPath, blogPostsMatter) {
  var route = (0, _createRoute.createRoute)(rootPath, BlogPath);
  var posts = getPosts(blogPostsMatter);

  route.getData = function () {
    return {
      path: BlogPath,
      posts: posts
    };
  };

  var postRoutes = (0, _BlogPosts.blogPostRoutes)(rootPath, blogPostsMatter);
  return [route].concat(postRoutes);
}